import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  FILE_TAB: `${cleanedFilename(__filename)}-file-tab`,
  LINK_TAB: `${cleanedFilename(__filename)}-link-tab`,
};
